export const BANK_DEBTS_PATH = '/debts/my-debts';

export const NEW_BANK_DEBT_PATH = `${BANK_DEBTS_PATH}/new`;

export const bankDebtPath = (id: string): string => `${BANK_DEBTS_PATH}/${id}`;

export const bankDebtEditPath = (id: string): string => `${bankDebtPath(id)}/edit`;
